// extracted by mini-css-extract-plugin
module.exports = {"logo":"style__logo__PgcIE","wrapper":"style__wrapper__5wU7Y"};